export const environment = {
	production: false,
	apiUrl: 'http://backofficeapi.novimostda.rs/api',
  currency: 'RSD'
};
